/** Push it real good */
export const connectToPusher = () => {
  try {
    const pusher = new Pusher(window.pwcc.config.PUSHER_APP_KEY, {
      cluster: window.pwcc.config.PUSHER_CLUSTER,
    });
    return pusher;
  } catch (error) {
    return null;
  }
};
export const subscribeToChannel = (pusherInstance, channelName) => {
  try {
    return pusherInstance?.subscribe(channelName);
  } catch (error) {
    return null;
  }
};
